import React, { useState, useEffect } from "react"
import { useMediaQuery } from "react-responsive"
import { useHistory, useLocation } from "react-router-dom"
import { nanoid } from "nanoid"

import { fbAuth } from "../../services/Firebase"
import { FaTimes } from "react-icons/fa"
import Navbar from "../../components/navbar/Navbar"
import MobileNav from "../../components/navbar/MobileNav"
import FavoriteDetailPage from "./FavoriteDetailPage"
import Service from "../../services/Service"

function FavoritePage() {
    const history = useHistory()
    const location = useLocation()
    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 600px)",
    })
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }
    const [ favoriteRecipes, setFavoriteRecipes ] = useState([])
    const [ favoriteWine, setFavoriteWine ] = useState([])
    const [ recipe, setRecipe ] = useState([])
    const [ wine, setWine ] = useState([])
    const [ showRecipePage, setShowRecipePage ] = useState( false )
    const [ showWinePage, setShowWinePage ] = useState( false )

    useEffect(() => {
        const getFavoriteData = () => {
            const recipes = Service.getDataFromLS( `${user.uid}-recipes` )
            const wine = Service.getDataFromLS( `${user.uid}-wine` )
            const uniqueRecipes = [...new Map(recipes.map(item => [item?.id, item])).values()]
            const uniqueWine = [...new Map(wine.map(item => [item?.id, item])).values()]
            setFavoriteRecipes( uniqueRecipes )
            setFavoriteWine( uniqueWine )
        }
        getFavoriteData()
    }, [ user.uid ])

    useEffect(() => {
        localStorage.removeItem( "null-recipes" )
        localStorage.removeItem( "undefined-recipes" )

        const checkRoute = () => {
            if ( location.pathname.includes("/favorite/recipe") ) {
                setShowWinePage( false )
                setShowRecipePage( true )
            } else if ( location.pathname.includes("/favorite/wine") ) {
                setShowRecipePage( false )
                setShowWinePage( true )
            } else if ( location.pathname === "/favorite" ) {
                setShowWinePage( false )
                setShowRecipePage( false )
            }
        }
        checkRoute()
    }, [
        setFavoriteRecipes, 
        showRecipePage, 
        setFavoriteWine,
        showWinePage,
        location.pathname
    ])

    const handleDelete = (e) => {
        const recipeId = Number( e.target.parentElement.id )
        const filteredRecipe = favoriteRecipes.filter( item => Number(item.id) !== Number(recipeId) )
        const wineId = Number( e.target.parentElement.id )
        const filteredWine = favoriteWine.filter( item => Number(item.id) !== Number(wineId) )
        setFavoriteRecipes(filteredRecipe)
        setFavoriteWine( filteredWine )
        Service.storeData( `${user.uid}-recipes`, filteredRecipe )
        Service.storeData( `${user.uid}-wine`, filteredWine )
        console.log("Delete successfully")
    }

    const handleRecipeRouting = (e) => {
        const recipeId = Number( e.target.parentElement.id )
        setRecipe( favoriteRecipes.filter( item => Number(item.id) === Number(recipeId) ) )
        history.push( `/favorite/recipe/${e.target.parentElement.id}` )
    }

    const handleWineRouting = (e) => {
        const wineId = Number( e.target.parentElement.id )
        setWine( favoriteWine.filter( item => Number(item.id) === Number(wineId) ) )
        history.push( `/favorite/wine/${e.target.parentElement.id}` )
    }

    return (
        <div className="favoritePage">
            { isMobileDevice ? <MobileNav /> : <Navbar /> }

            { showRecipePage
                ?   <FavoriteDetailPage data={recipe} />

                :   showWinePage
                    ?   <FavoriteDetailPage data={wine} />
                    :   <section className="favoriteContainer">
                        {favoriteRecipes?.map( item => {
                            return  <article id={item?.id} className="recipeTile favoriteRecipe" key={nanoid()} >
                                <button onClick={handleDelete}><FaTimes/></button>
                                <img src={item?.image} alt="Favorite Recipe" onClick={handleRecipeRouting} />
                                <h2>{item?.title}</h2>
                            </article>
                        })}

                        {favoriteWine?.map( item => {
                            return  <article id={item?.id} className="recipeTile favoriteWine" key={nanoid()} >
                                <button onClick={handleDelete}><FaTimes/></button>
                                <img src={item?.imageURL} alt="Favorite Wine" onClick={handleWineRouting} />
                                <h2>{item?.title}</h2>
                            </article>
                        })}
                    </section>
            }
        </div>
    )
}

export default FavoritePage
